// store/authStore.js
import { create } from "zustand";
import { getBannerData } from "../api/home";
import { getProject } from "../api/project";

export const useProjectStore = create((set, get) => ({
    loading: true,
    project: [],
    projectCache: {},
    projectPage: null,
    projectForProject: [],


    setProjectPage: (pageNumber, data) =>
        set((state) => ({
            projectForProject: data,
            projectCache: { ...state.projectCache, [pageNumber]: data },
        })),

    setProjectCache: (key, data) =>
        set((state) => ({
            projectCache: { ...state.projectCache, [key]: data },
            projectForProject: data,
        })),

    getBanner: async () => {
        try {
            set({ loading: true });
            const res = await getBannerData("project");
            set({ loading: false, banner: res });
            return res;
        } catch (error) {
            console.log("Error in getBanner:", error);
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },

    getProject: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true });
            const res = await getProject(pageNumber, pageSize, search, field);
            set({
                loading: false,
                project: res?.ref,
                projectPage: res?.project,
            });
            return res;
        } catch (error) {
            console.log("Error in getProject:", error);
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },

    getProjectForProjectPage: async (pageNumber, pageSize, search, field) => {
        const key = `${pageNumber}-${pageSize}`;
        const { projectCache } = get();

        if (projectCache[key]) {
            set({
                projectForProject: projectCache[key],
                loading: false,
            });
            return { ref: projectCache[key], totalItems: projectCache.totalItems };
        }


        try {
            set({ loading: true });
            const res = await getProject(pageNumber, pageSize, search, field);
            set((state) => ({
                loading: false,
                projectForProject: res?.ref,
                projectPage: res?.project,
                projectCache: {
                    ...state.projectCache,
                    [key]: res?.ref,
                    totalItems: res?.totalItems,
                },
            }));
            return res;
        } catch (error) {
            console.log("Error in getProjectForProjectPage:", error);
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },

}));
